import { Suspense, lazy } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import { common } from '@ocean/ui'
import { PublicRoute } from 'routing/components'
import authRoutes from 'modules/Auth/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const ProxyRedirect = lazy(
  () =>
    import(
      /* webpackChunkName: "ProxyRedirect" */ 'modules/redirects/ProxyRedirect/pages/ProxyRedirect'
    )
)

const ProxyRedirectRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <PublicRoute exact path={routes.root} component={ProxyRedirect} />
      <Redirect path='*' to={authRoutes.login} />
    </Switch>
  </Suspense>
)

export default ProxyRedirectRouting
